import React, { useEffect } from 'react'
import { useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import DashboardLayout from '../../components/DashboardLayout';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { api_url, AXIOS_HEADER } from '../../constants/data';
import moment from 'moment';
import CommentsModal from './commentsModal';
import { useSelector } from 'react-redux';

const SelectedTask = () => {
    const navigate = useNavigate(); 
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null)
    const fileTypes = ["jpg", "png", "pdf", "xlxs", "doc"];
    const [task, setTask] = useState(null);   
    const { id } = useParams();
    const [showComments, setShowComments] = useState(false);
    const userState = useSelector(state => state.auth?.user);

    useEffect(() => {
        axios.post(`${api_url}/task/${id}`, {}, AXIOS_HEADER)
            .then((res) => {
                setTask(res.data)

                setIsChecked1(res.data.is_finished)
                setIsChecked2(res.data.is_cancelled)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [id])

    const handleCheckbox1Change = () => {
        setIsChecked1(!isChecked1);
        setIsChecked2(false);
        console.log("alert1");
    };

    const handleCheckbox2Change = () => {
        setIsChecked2(!isChecked2);
        setIsChecked1(false);
        console.log("alert2");
    };

    const handleChange = (file) => {
        setSelectedFile(file);
    };

    if(!task) {
        return <div>Loading...</div>
    }

    const submit = () => {
        const payload = {
            is_finished: isChecked1,
            is_cancelled: isChecked2,
            task_id: id
        }

        axios.post(`${api_url}/task/${id}/update`, payload, AXIOS_HEADER)
            .then(res => {
                navigate(`/task/${id}`)
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <DashboardLayout>
            <div className="header_wrapper">
                <div className="header_icon">
                    <img src="/icons/flag.png" alt="" />
                </div>
                <div className="header_title">
                    <p>{ task.title }</p>
                </div>
            </div>
            <div className="task-details-main">
                <div className="task-details-header">
                    <span className='author'>ჩანაწერის ავტორი: <p>{ task.user.name } { task.user.lastname }</p></span>
                    { task.user_id == userState?.id && (
                        <div className="checkboxes">
                            <label htmlFor="checkbox1">
                                <input type="checkbox"
                                    id="checkbox1"
                                    checked={isChecked1}
                                    onChange={handleCheckbox1Change} />
                                <span class="fake-checkbox"></span>
                                <span class="text">შესრულება</span>
                            </label>
                            <label htmlFor="checkbox2">
                                <input type="checkbox"
                                    id="checkbox2"
                                    checked={isChecked2}
                                    onChange={handleCheckbox2Change} />
                                <span class="fake-checkbox"></span>
                                <span class="text">გაუქმება</span>
                            </label>
                        </div>
                    )}

                </div>
                <form action="">
                    <div className='task-details-inner'>
                        <div className="task-details-option">
                            <p>დასაწყისი:</p>
                            <strong>{ moment(task.date_start).format('YYYY-MM-DD') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>დასასრული:</p>
                            <strong>{ moment(task.date_end).format('YYYY-MM-DD') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>დავალება:</p>
                            <strong>{ task.title }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>განყოფილება:</p>
                            <strong>{ task.departments.map(x => x.department.short_name).join(', ') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>შემსრულებელი:</p>
                            <strong>{ task.users.filter(x => x.is_cc == 0).map(x => x.user.name + " " + x.user.lastname).join(', ') }</strong>
                        </div>
                        <div className="task-details-option cc">
                            <p>Cc:</p>
                            <strong>{ task.users.filter(x => x.is_cc == 1).map(x => x.user.name + " " + x.user.lastname).join(', ') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>მიბმული ფაილი:</p>
                            { task.attachments && task.attachments.map((attachment, index) => (
                                <a href={attachment.file} target='blank' key={index}>ფაილი_{index}</a>  
                            ))}
                        </div>
                        <div className="task-details-option">
                            <p>Forward:</p>
                            <strong>{ task.user_forwards.map(x => x.user.name + " " + x.user.lastname).join(', ') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>შინაარსი:</p>
                            <strong>{ task.description }</strong>
                        </div>
                    </div>
                    <div className="task-details-buttons">
                        <button type='button' onClick={() => navigate('/dashboard')}>უკან</button>
                        <button type='button' onClick={() => navigate(`/task/${task.id}/forward`)}>დაფორვარდება</button>
                        <button type='button' onClick={submit}>შენახვა</button>
                    </div>
                    <span className="taskread">დავალება წაიკითხა: <p>{ task.user_read_info.map(x => x.user.username).join(', ') }</p></span>
                    <button className="comentsbutton" type='button' style={{ position: 'relative' }} onClick={() => setShowComments(true)}>
                        <img src="/icons/chat1.png" alt="" />
                        <p>კომენტარები ({ task.comments.length })</p>
                        {!task.comment_read && task.comments.length > 0 && (
                            <span className="unread" style={{ left: '36px', top: '4px', right: 'unset' }}>*</span>
                        )}
                    </button>
                  
                    
                </form>
            </div >

            { showComments && (
                <CommentsModal id={task.id} close={() => setShowComments(false)} />
            ) }
        </DashboardLayout>
        
    )
}

export default SelectedTask